<template>
  <v-card>
    <v-card-title class="filtro-header">
      <span class="filtro-header-title">Filtrar Cotação</span>
      <v-spacer></v-spacer>
      <v-btn icon flat dark class="ma-0" @click="$emit('fechar')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text class="px-4 pt-3 pb-0">
      <v-layout row wrap>
        <v-flex xs12 sm6 class="px-2">
          <v-text-field
            v-model="numeroReserva"
            label="Nº da Reserva"
            placeholder="000000"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 class="px-2">
          <v-select
            v-model="listaIdStatus"
            :items="opcoesStatus"
            item-text="titulo"
            item-value="id"
            label="Status"
            placeholder="Selecione"
            multiple
            clearable
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 class="px-2">
          <v-text-field
            v-model="cnpj"
            label="CNPJ"
            placeholder="00.000.000/0000-00"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 class="px-2">
          <v-text-field
            v-model="razaoSocial"
            label="Razão Social"
            placeholder="Razão Social"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 class="px-2">
          <v-autocomplete
            v-model="listaIdUsuarioCorretor"
            :items="opcoesCorretor"
            item-text="nome"
            item-value="id"
            label="Corretor Parceiro"
            placeholder="Digite para buscar"
            no-data-text="Nenhuma opção encontrada"
            multiple
            clearable
          >
            <template v-slot:prepend-item>
              <v-list-tile ripple @click="selecionarTodosCorretor">
                <v-list-tile-action>
                  <v-icon style="color: #00456e">{{ iconeSelecionarTodosCorretor }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Selecionar todos</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 class="px-2">
          <v-autocomplete
            v-model="listaIdGrupoUsuario"
            :items="opcoesEmpresa"
            item-text="nome"
            item-value="id"
            label="Empresa Parceira"
            placeholder="Digite para buscar"
            no-data-text="Nenhuma opção encontrada"
            multiple
            clearable
          >
            <template v-slot:prepend-item>
              <v-list-tile ripple @click="selecionarTodosEmpresa">
                <v-list-tile-action>
                  <v-icon style="color: #00456e">{{ iconeSelecionarTodosEmpresa }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Selecionar todos</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 class="px-2">
          <v-autocomplete
            v-model="listaNomeTecnicoResponsavel"
            :items="opcoesTecnico"
            label="Técnico Responsável"
            placeholder="Digite para buscar"
            no-data-text="Nenhuma opção encontrada"
            multiple
            clearable
          >
            <template v-slot:prepend-item>
              <v-list-tile ripple @click="selecionarTodosTecnico">
                <v-list-tile-action>
                  <v-icon style="color: #00456e">{{ iconeSelecionarTodosTecnico }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Selecionar todos</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-autocomplete>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-card-actions class="px-4 pb-3">
      <v-btn flat color="primary" @click="$emit('fechar')">FECHAR</v-btn>
      <v-spacer></v-spacer>
      <v-btn flat color="themeGrey" @click="limpar">LIMPAR</v-btn>
      <v-btn color="primary" @click="aplicar">FILTRAR</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ModalFiltroCorretor",
  props: {
    filtroInicial: {
      type: Object,
      default: null
    },
    opcoesStatus: {
      type: Array,
      default: () => []
    },
    opcoesTecnico: {
      type: Array,
      default: () => []
    },
    opcoesCorretor: {
      type: Array,
      default: () => []
    },
    opcoesEmpresa: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      cnpj: this.filtroInicial ? (this.filtroInicial.cnpj || null) : null,
      razaoSocial: this.filtroInicial ? (this.filtroInicial.razaoSocial || null) : null,
      numeroReserva: this.filtroInicial ? (this.filtroInicial.numeroReserva || null) : null,
      listaIdStatus: this.filtroInicial ? (this.filtroInicial.listaIdStatus || []) : [],
      listaNomeTecnicoResponsavel: this.filtroInicial ? (this.filtroInicial.listaNomeTecnicoResponsavel || []) : [],
      listaIdUsuarioCorretor: this.filtroInicial ? (this.filtroInicial.listaIdUsuarioCorretor || []) : [],
      listaIdGrupoUsuario: this.filtroInicial ? (this.filtroInicial.listaIdGrupoUsuario || []) : []
    };
  },
  computed: {
    iconeSelecionarTodosTecnico() {
      return this.listaNomeTecnicoResponsavel.length === this.opcoesTecnico.length && this.opcoesTecnico.length > 0
        ? "check_box"
        : "check_box_outline_blank";
    },
    iconeSelecionarTodosCorretor() {
      return this.listaIdUsuarioCorretor.length === this.opcoesCorretor.length && this.opcoesCorretor.length > 0
        ? "check_box"
        : "check_box_outline_blank";
    },
    iconeSelecionarTodosEmpresa() {
      return this.listaIdGrupoUsuario.length === this.opcoesEmpresa.length && this.opcoesEmpresa.length > 0
        ? "check_box"
        : "check_box_outline_blank";
    }
  },
  methods: {
    selecionarTodosTecnico() {
      this.listaNomeTecnicoResponsavel =
        this.listaNomeTecnicoResponsavel.length === this.opcoesTecnico.length ? [] : this.opcoesTecnico.slice();
    },
    selecionarTodosCorretor() {
      this.listaIdUsuarioCorretor =
        this.listaIdUsuarioCorretor.length === this.opcoesCorretor.length
          ? []
          : this.opcoesCorretor.map(o => o.id);
    },
    selecionarTodosEmpresa() {
      this.listaIdGrupoUsuario =
        this.listaIdGrupoUsuario.length === this.opcoesEmpresa.length
          ? []
          : this.opcoesEmpresa.map(o => o.id);
    },
    aplicar() {
      this.$emit("filtrar", {
        cnpj: this.cnpj || "",
        listaIdStatus: this.listaIdStatus || [],
        razaoSocial: this.razaoSocial || "",
        numeroReserva: this.numeroReserva || "",
        listaNomeTecnicoResponsavel: this.listaNomeTecnicoResponsavel || [],
        listaIdUsuarioCorretor: this.listaIdUsuarioCorretor || [],
        listaIdGrupoUsuario: this.listaIdGrupoUsuario || []
      });
    },
    limpar() {
      this.cnpj = null;
      this.razaoSocial = null;
      this.numeroReserva = null;
      this.listaIdStatus = [];
      this.listaNomeTecnicoResponsavel = [];
      this.listaIdUsuarioCorretor = [];
      this.listaIdGrupoUsuario = [];
      this.$emit("limpar");
    }
  }
};
</script>

<style scoped>
.filtro-header {
  background-color: #00456e;
  padding: 12px 20px;
}
.filtro-header-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalFiltroCorretor.vue